/**
 * Converts a raw alias input to a normalized format for storage.
 *
 * @param rawAlias - The raw alias string from user input
 * @returns A normalized alias string with whitespace replaced by hyphens and converted to lowercase
 */
export const toSanitizedAlias = (rawAlias: string): string => {
  const trimmed = (rawAlias || '').trim();
  if (!trimmed) return '';

  const normalized = trimmed.replace(/\s+/g, '-').toLowerCase();
  return normalized;
};

/**
 * Converts a sanitized alias back to a human-readable display format.
 *
 * @param sanitizedAlias - The normalized alias string from storage
 * @returns A formatted alias string with title case words separated by spaces
 */
export const toDisplayAlias = (sanitizedAlias: string): string => {
  const normalized = (sanitizedAlias || '').replace(/[-_]+/g, ' ').trim();
  if (!normalized) return '';

  const words = normalized.split(' ');
  const capitalizedWords = words.map((word) => {
    if (!word) return '';

    const firstLetter = word[0].toUpperCase();
    const restOfWord = word.slice(1);
    return firstLetter + restOfWord;
  });

  return capitalizedWords.join(' ');
};
